<template>
    <div>
        <v-progress-circular v-show="isLoadingUser" :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
        <div v-show="!isLoadingUser" id="firebaseui-auth-container" style="border: green solid 1px"></div>
    </div>
</template>

<script>
import firebase from "firebase";
import firebaseui from "firebaseui";
import { mapGetters } from "vuex";
import _debug from "debug";

const debug = _debug("Mediacao:views:Login.vue");

export default {
    name: "login",
    data: () => ({
        email: "",
        password: "",
    }),
    computed: mapGetters(["isLoadingUser"]),
    mounted: () => {
        const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
        const uiConfig = {
            callbacks: {
                signInSuccessWithAuthResult: (authResult, redirectUrl) => {
                    // User successfully signed in.
                    // Return type determines whether we continue the redirect automatically
                    // or whether we leave that to developer to handle.
                    debug("signInSuccessWithAuthResult", authResult, redirectUrl);
                    return true;
                },
                uiShown: () => {
                    // The widget is rendered.
                    // Hide the loader.
                    const loader = document.getElementById("loader");
                    if (loader) {
                        loader.style.display = "none";
                    }
                },
            },
            // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
            signInFlow: "popup",
            signInSuccessUrl: "/",
            signInOptions: [
                // Leave the lines as is for the providers you want to offer your users.
                firebase.auth.GoogleAuthProvider.PROVIDER_ID,
                // firebase.auth.FacebookAuthProvider.PROVIDER_ID,
                // firebase.auth.TwitterAuthProvider.PROVIDER_ID,
                // firebase.auth.GithubAuthProvider.PROVIDER_ID,
                firebase.auth.EmailAuthProvider.PROVIDER_ID,
                // firebase.auth.PhoneAuthProvider.PROVIDER_ID
            ],
            // Terms of service url.
            // tosUrl: "<your-tos-url>",
            // Privacy policy url.
            // privacyPolicyUrl: "<your-privacy-policy-url>"
        };
        ui.start("#firebaseui-auth-container", uiConfig);
    },
    methods: {},
};
</script>
